var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M9,11.1c-1-0.2-2-0.1-2.9,0.3c-0.9,0.4-1.7,1-2.2,1.8S3,15,3,16c0,1,0.3,2,0.8,2.8s1.3,1.5,2.2,1.8 C7,21,8,21.1,9,20.9c1-0.2,1.8-0.7,2.5-1.3l1.1-1.2c0.4-0.4,1-0.5,1.4-0.1c0.4,0.4,0.5,1,0.1,1.4L13,20.9c0,0,0,0,0,0 c-1,1-2.2,1.6-3.6,1.9c-1.4,0.3-2.8,0.1-4-0.4C4.1,21.9,3,21,2.2,19.9C1.4,18.7,1,17.4,1,16c0-1.4,0.4-2.7,1.2-3.9 c0.8-1.1,1.9-2,3.1-2.6C6.6,9,8,8.9,9.4,9.1c1.4,0.3,2.6,0.9,3.6,1.9c0,0,0,0,0,0l7.5,8.5c0.7,0.7,1.6,1.2,2.5,1.3 c1,0.2,2,0.1,2.9-0.3c0.9-0.4,1.7-1,2.2-1.8C28.7,17.9,29,17,29,16c0-1-0.3-1.9-0.8-2.8c-0.5-0.8-1.3-1.5-2.2-1.8 C25,11,24,10.9,23,11.1c-1,0.2-1.8,0.7-2.5,1.3l-1.1,1.2c-0.4,0.4-1,0.5-1.4,0.1c-0.4-0.4-0.5-1-0.1-1.4l1.1-1.2c0,0,0,0,0,0 c1-1,2.2-1.6,3.6-1.9c1.4-0.3,2.8-0.1,4,0.4c1.3,0.5,2.4,1.4,3.1,2.6c0.8,1.1,1.2,2.5,1.2,3.9c0,1.4-0.4,2.7-1.2,3.9 c-0.8,1.1-1.9,2-3.1,2.6s-2.7,0.7-4,0.4s-2.6-0.9-3.6-1.9c0,0,0,0,0,0l-7.5-8.5C10.8,11.8,9.9,11.3,9,11.1z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoop);
export default __webpack_public_path__ + "static/media/loop.526332ce.svg";
export { ForwardRef as ReactComponent };